<template>
    <div class='product-container'>

        <br />
        <v-text-field solo clearable
                      autocomplete="off"
                      autofocus
                      ref="inputSearchSymptomRef"
                      id="inputSearchSymptomId"
                      v-model="searchSymptomInputValue"
                      @mousedown.stop
                      @focus ="navSetCursorOnSearchInput"
                      :label="text('api.search.label') + '...'"
                      prepend-icon="search"
                      class="input-searchSymptom border-color-primary"
        >
        </v-text-field>
        <br />
        <v-card v-if="searchSymptomInputValue" class="no-chapter-list search-symptom-card"
                :class="{'panel-highlighted': shortcutNav.isPanelHighlight === true && shortcutNav.crtPanel === 'SEARCH'}"
                ref="vCardSearchResultRef">

            <!-- Search RESULTS. -->
            <v-radio-group v-show="getSearchSymptomResultList.length" v-model="getSelectedMainSymptomCode">

                <div @click="handleSymptomSelection(searchResultSymptom.code)" v-for="searchResultSymptom in getSearchSymptomResultList" class="margin-bottom-s cursor-pointer search-main-symptom-pro-wrapper">

                    <div class="search-main-symptom-block"
                         :class="{'symptom-highlighted': shortcutNav.isKeyboardNav === true && !mustShowScoringPopup && !showComment && shortcutNav.isPanelHighlight === false
                                                                          && shortcutNav.crtPanel === 'SEARCH' && shortcutNav.crtSymptom === searchResultSymptom.code}"
                    >
                        <v-radio :value="searchResultSymptom.code"
                                 :key="searchResultSymptom.code"
                                 color="primary"
                                 :ref="'vRadioSymptomsSearchRef_' + searchResultSymptom.code"
                                 :id="'S_SEARCH_' + searchResultSymptom.code"
                                 class="check-main-symptom">
                        </v-radio>
                        <p class="main-symptom-radio-label"
                           v-html="searchResultSymptom.name.text.replace(searchResultSymptom.name.match, '<b>' + searchResultSymptom.name.match + '</b>')">

                        </p>
                    </div>

                    <div v-if="searchResultSymptom.synonyms">
                                    <span v-for="synonym in searchResultSymptom.synonyms" class="synonyms font-size-small">
                                         <span v-html="synonym.text.replace(synonym.match, '<b>' + synonym.match + '</b>' ) + ' ' + '<b>&#124;</b>' + ' '"></span>
                                    </span>
                    </div>
                </div>

            </v-radio-group>
            <!-- No search results. :( -->
            <div v-show="!getSearchSymptomResultList.length && !getIsLoadingSearchResults">
                <span>{{text("api.pro.chooseMainSymptomPage.search.noResults")}}</span>
            </div>
            <!-- Pending search request... -->
            <div v-show="getIsLoadingSearchResults" class="symptom-searching-text">
                <span>{{text("api.pro.chooseMainSymptomPage.search.searching")}}</span>
            </div>
        </v-card>

        <v-list v-if="!searchSymptomInputValue" subheader class="symptom-category" id ="vListChaptersId" ref="vListChaptersRef"
                :style="this.shortcutNav.isPanelHighlight && shortcutNav.crtPanel === 'CHAPTER' ? {} : ''">
            <v-list-tile avatar v-for="chapter in getChapterTree.chapters"
                         :key="chapter.code"
                         :id="'CHAPTER_' + chapter.code"
                         @click="selectChapter(chapter)"
                         :class="{highlight:(chapter.code === getActiveChapterCode),
                         'chapter-highlighted': shortcutNav.isKeyboardNav === true &&!mustShowScoringPopup && !showComment && shortcutNav.isPanelHighlight === false
                                                && shortcutNav.crtPanel === 'CHAPTER' && shortcutNav.crtChapter === chapter.code}"
                         v-if="(chapter.subChapters && chapter.subChapters.length > 0) || (chapter.symptoms && chapter.symptoms.length >0)">
                <v-list-tile-avatar>
                    <chapter-icon :image="chapter.imagePath"></chapter-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title>{{chapter.name}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import ChapterIcon from "./ChapterIcon";
import Vue from "vue";
import axios from 'axios/dist/axios';

export default {
        name: 'Chapters',

        components: {
            ChapterIcon
        },

        props: [
            "shortcutNav",
            "showComment"
        ],
        data() {
            return {
                radioButtonPlugin: Vue.RadioButton.RadioButtonSvg
            }
    },

        mounted() {

            let chapterList = this.$refs['vListChaptersRef'];
            let that = this;

            if (chapterList != null) {
                chapterList.$el.onclick = function () {

                    that.shortcutNav.crtPanel = "CHAPTER";
                };
            }
        },

        computed: {
            ...mapGetters({
                getChapterTree: 'ChooseMainSymptomStore/getChapterTree',
                getActiveChapter: 'ChooseMainSymptomStore/getActiveChapter',
                getActiveChapterCode: 'ChooseMainSymptomStore/getActiveChapterCode',
                mustShowScoringPopup: 'AssessmentAlertsStore/getMustShowScoringPopup',
                getSearchSymptomResultList: 'ChooseMainSymptomStore/getSearchSymptomResultList',
                getIsLoadingSearchResults: 'ChooseMainSymptomStore/getIsLoadingSearchResults',
                getSelectedMainSymptomCode: 'ChooseMainSymptomStore/getSelectedMainSymptomCode',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                mustShowVitalParametersForm: 'VitalParametersStore/getMustShowVitalParamsForm',
            }),
            searchSymptomInputValue: {
                get: function(){
                    return this.$store.state["ChooseMainSymptomStore"].searchSymptomInputValue;
                },
                set: function(newValue){
                    this.$store.commit('ChooseMainSymptomStore/setSearchSymptomInputValue', newValue);
                    this.$store.commit('ChooseMainSymptomStore/setActiveChapter', null); // Unselect chapter.
                    this.$store.dispatch('ChooseMainSymptomStore/submitSearchSymptom', newValue).then((response) => {
                        this.$emit('isSearchSymptomResultList');
                    });
                }
            },
            getSelectedMainSymptomCode: {
                get() {
                    return this.$store.getters['ChooseMainSymptomStore/getSelectedMainSymptomCode'];
                },
                set (newVal) {
                    this.$store.commit('ChooseMainSymptomStore/setSelectedMainSymptomCode', newVal);
                }
            }
        },
        watch: {
            getSearchSymptomResultList(newValue, oldValue) {

                if (this.getSearchSymptomResultList.length) {

                    let searchResultPanel = this.$refs['vCardSearchResultRef'];
                    if (searchResultPanel != null) {

                        let that = this;
                        searchResultPanel.$el.onclick = function () {
                            that.shortcutNav.crtPanel = "SEARCH";
                        }
                    }
                    let that = this;
                    setTimeout(function() {
                        let searchSymptomSection = document.getElementsByClassName('search-symptom-card');
                        if(searchSymptomSection[0]) {
                            let inputSelected = searchSymptomSection[0].getElementsByClassName('input-group--active');

                            if (inputSelected[0]) {
                                let radio = inputSelected[0].getElementsByClassName('icon--radio');
                                radio[0].innerHTML = that.radioButtonPlugin();
                            }
                        }
                    }, 10);

                }
            },
            searchSymptomInputValue(newValue) {

                if (newValue !== "") {
                    this.shortcutNav.crtPanel= "SEARCH";
                    this.$nextTick(() => {
                        this.$parent.navScrollIntoViewSearchPanel();
                    });
                }
                else {
                    this.shortcutNav.crtPanel= "CHAPTER";
                }


            },
            mustShowVitalParametersForm(newValue) {
                // When opening the VitalParametersForm we need to lose the focus on the search symptom input to avoid writing in the input while the VitalParameters is opened.
                // When closing the VitalParametersForm we focus it again.
                if (newValue === true) {
                    this.$refs['inputSearchSymptomRef'].$refs.input.blur();
                }
                else {
                    this.$refs['inputSearchSymptomRef'].$refs.input.focus();
                }
            }
        },
        methods: {
            selectChapter (chapterObj) {
                this.$store.dispatch('ChooseMainSymptomStore/resetSearchSymptom');
                this.$store.commit('ChooseMainSymptomStore/setActiveChapter', chapterObj);

                // handle click
                this.onChapterPanelClick();
            },
            navSetCursorOnSearchInput() {

                // When focus place cursor at the end text field for IE11
                if (document.getElementById("inputSearchSymptomId") != null) {

                    let textFieldPidId = document.getElementById("inputSearchSymptomId");
                    let pidLength = textFieldPidId.value.length;

                    textFieldPidId.selectionStart = pidLength;
                    textFieldPidId.selectionEnd = pidLength;
                }
            },
            handleSymptomSelection (newSelectedSymptomCode) {
                this.$store.commit('ChooseMainSymptomStore/setSelectedMainSymptomCode', newSelectedSymptomCode);
                this.onSearchSymptomClick(newSelectedSymptomCode);

                axios.post(process.env.API_BASE_URL + '/assessment/clickMainSymptom', {
                    symptomCode: newSelectedSymptomCode
                });
            },

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***      BEGIN CODE         ***
             *******************************/

            onChapterPanelClick() {

                if (this.getActiveChapter) {

                    this.shortcutNav.crtPanel = "CHAPTER";
                    this.shortcutNav.crtChapter = this.getActiveChapter.code;

                    this.shortcutNav.crtSubchapter = null;
                    this.shortcutNav.crtSymptom = null;
                }
            },

            onSearchSymptomClick(symptomCode) {

                this.shortcutNav.crtPanel = "SEARCH";
                this.shortcutNav.crtSymptom = symptomCode;
            },


            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***        END CODE         ***
             *******************************/
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" >
    /* ... */
   /* .st0  {
        fill: #434D51;
    }

    .symptom-category{
        border-radius: 7px;
       // margin-top: 20px;
        padding-top: 15px;

        a {
            padding: 18px 10px 18px 25px;
            border-left: 3px solid white;

            .list__tile__content .list__tile__title {
               // font-weight: $font-weight-light;
                font-weight: $font-weight-regular;
                font-size: $font-size-default;
                color: $color-body-text;
            }
        }

        .highlight a {
            border-left: 3px solid $color-brand-primary;

            .list__tile__content .list__tile__title {
            }
                color: $color-brand-primary;
        }

        .highlight.search a{
            border-left: 3px solid $color-lightest !important;

            .list__tile__content .list__tile__title {
                color: $color-body-text;
            }
        }

        div:hover a .list__tile__content .list__tile__title,
        li:hover a .list__tile__content .list__tile__title {
            color: $color-brand-primary;
        }

        div.highlight.search:hover a .list__tile__content .list__tile__title {
            color: $color-brand-primary;
        }
    }

    .symptom-category div.highlight.search svg path.st0 {
        fill: $color-body-text;
    }

    .symptom-category div:hover svg path.st0,
    .symptom-category li:hover svg path.st0,
    .symptom-category div.highlight svg path.st0,
    .symptom-category div.highlight.search:hover svg path.st0 {
        fill: $color-brand-primary;
    }

    .symptom-category .highlight a .st0 {
        fill: $color-brand-primary;
    }


    @media only screen and (min-width: 1025px) {
        .symptom-category {
            min-height: 610px;
        }
    }

    @media only screen and (min-height:901px) and (max-width: 1024px) {
        .symptom-category {
            min-height: 400px;
        }
    }

    @media only screen and (min-width: 700px) and (max-width: 900px) {
        .symptom-category {
            min-height: 500px;
        }
    }*/

</style>



// WEBPACK FOOTER //
// src/professional/components/choose-main-symptom/Chapters.vue